import {useEffect} from 'react'
import {useParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import {
	broadcastEventRefresh,
	setupEventRefreshListener,
} from 'shared/lib/eventBroadcast'

const usePostEventClose = () => {
	const [fetchResult, fetchRequest] = useFetch()
	const {idx} = useParams()
	const [, setAlert] = useAlertModalAtom()

	// Listen for broadcast from other tabs to refresh
	useEffect(() => {
		return setupEventRefreshListener(idx)
	}, [idx])

	const request = () => {
		let url = `/admin/event/${idx}/close`

		fetchRequest('POST', url)
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				// Broadcast to other tabs to refresh
				broadcastEventRefresh(idx)
				window.location.reload()
				break
			case 400:
				if (fetchResult?.data?.error_code === 'event_idx')
					setAlert('대회 idx를 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 1)
					setAlert('대회 상태가 진행 중이 아닙니다.')
				else if (fetchResult?.data?.error_code === 2)
					setAlert('등록된 참가자 2명 이상이어야 합니다.')
				else if (fetchResult?.data?.error_code === 3)
					setAlert('탈락 처리된 참가자가 없습니다.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('대회 데이터가 존재하지 않습니다.')
				break
		}
	}, [fetchResult])

	return [request]
}

export default usePostEventClose
